import * as React from 'react';
import {SVGSource} from '@shopify/images';

import {Icon} from 'components/UIKit';
import logo from '../../icons';
import * as styles from './Logo.scss';

const DEFAULT_LOGO_ATTRIBUTES = {
  alt: 'Home',
  dataGaAction: 'Logo',
  dataGaEvent: 'Main Nav',
  fill: 'white',
  href: '/',
  iconStyle: {width: '120px', height: '30px'},
  sourceSVG: logo,
};

interface LogoProps {
  alt?: string;
  dataGaAction?: string;
  dataGaEvent?: string;
  fill?: string;
  href?: string;
  iconStyle?: React.CSSProperties;
  sourceSVG?: SVGSource;
}

export function Logo(props: LogoProps) {
  const {
    alt = DEFAULT_LOGO_ATTRIBUTES.alt,
    dataGaAction = DEFAULT_LOGO_ATTRIBUTES.dataGaAction,
    dataGaEvent = DEFAULT_LOGO_ATTRIBUTES.dataGaEvent,
    fill = DEFAULT_LOGO_ATTRIBUTES.fill,
    href = DEFAULT_LOGO_ATTRIBUTES.href,
    iconStyle = DEFAULT_LOGO_ATTRIBUTES.iconStyle,
    sourceSVG = DEFAULT_LOGO_ATTRIBUTES.sourceSVG,
  } = props;

  return (
    <a
      className={styles.logoLink}
      href={href}
      data-ga-event={dataGaEvent}
      data-ga-action={dataGaAction}
    >
      <Icon
        alt={alt}
        fill={fill}
        sourceSVG={sourceSVG}
        style={iconStyle}
      />
    </a>
  );
}

export default Logo;
